import { useMessageApi } from "../../../../provider/AntdNotification";
import ButtonWrapper from "../../../components/reuseComp/ButtonWrapper";
import {
  Form,
  Input,
  Spin,
  Switch,
  InputNumber,
  Button,
  Space,
  Card,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useServiceDetails,
  useServiceSave,
} from "../../../../hooks/api/service/hooks";
import UploadFoodImage from "../../../../lib/UploadFoodImage";
import { removeSpecialChars } from "../../../../lib/utils";

interface Props {
  qData: any;
  id?: any;
}

const { TextArea } = Input;

const ServiceForm: React.FC<Props> = ({ qData, id }) => {
  const [form] = Form.useForm();
  const message = useMessageApi();
  const navigate = useNavigate();
  const isEditPage = Boolean(id);

  const { mutate: saveService, isPending } = useServiceSave({ qData });
  const { data: serviceDetails, isLoading } = useServiceDetails(id);

  const watchTitle = Form.useWatch("title", form);


  console.log(serviceDetails,"service-details");

  useEffect(() => {
    if (isEditPage && serviceDetails?.data) {
      form.setFieldsValue(serviceDetails.data);
    }
  }, [isEditPage, serviceDetails, form]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();

      saveService(
        { ...values, _id: id },
        {
          onSuccess: () => {
            message.success(
              isEditPage
                ? "Service updated successfully"
                : "Service created successfully",
            );
            navigate(-1);
          },
          onError: () => message.error("Failed to save Service"),
        },
      );
    } catch (err) {
      console.error(err);
    }
  };

  const showSpinner = isEditPage && isLoading;

  useEffect(() => {
    if (!isEditPage) {
      form.setFieldValue("slug", removeSpecialChars(watchTitle));
    }
  }, [watchTitle, isEditPage, form]);

  return (
    <div>
      <div className="bg-[#F9F9F9] p-3 md:p-6 rounded-2xl shadow-sm mb-6">
        <Spin spinning={showSpinner} tip="Loading Service details...">
          <Form layout="vertical" form={form}>
            {/* BASIC INFO */}
            <Form.Item name="_id" hidden>
              <Input />
            </Form.Item>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item
                label="Title"
                name="title"
                rules={[{ required: true, message: "Please enter title" }]}
              >
                <Input placeholder="Service title" />
              </Form.Item>

              <Form.Item
                label="Slug"
                name="slug"
                
                rules={[{ required: true, message: "Please enter slug" }]}
              >
                <Input placeholder="Slug" disabled={isEditPage} />
              </Form.Item>
            </div>
            <Form.Item
              label="Short Description"
              name="short_description"
              rules={[
                { required: true, message: "Please enter short description" },
              ]}
            >
              <TextArea rows={2} placeholder="Short description" />
            </Form.Item>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Form.Item label="Service Thumbnail Image" name="feature_image">
                <UploadFoodImage
                  maxUploadCount={1}
                  isCropTrue={false}
                  bannerAspect={1 / 1}
                  text="Service Thumbnail Image"
                />
              </Form.Item>

              {/* STATUS + ORDER */}
              <div className="space-y-2">
                <Form.Item
                  label="Status"
                  name="status"
                  valuePropName="checked"
                  rules={[{ required: true, message: "Please select status" }]}
                >
                  <Switch
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                  />
                </Form.Item>

                <Form.Item
                  label="Order"
                  name="order"
                  rules={[{ required: true, message: "Please enter order" }]}
                >
                  <InputNumber
                    placeholder="Order"
                    min={0}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </div>
            </div>

            <Card size="small" title="Banner Section">
              <Form.Item
                label="Banner Title"
                name={["banner", "title"]}
                rules={[{ required: true, message: "Enter banner title" }]}
              >
                <Input placeholder="Banner title" />
              </Form.Item>

              <Form.Item
                label="Banner Image"
                name={["banner", "image"]}
                rules={[
                  { required: true, message: "Please provide banner image" },
                ]}
              >
                <UploadFoodImage
                  maxUploadCount={1}
                  isCropTrue={true}
                  bannerAspect={3 / 1}
                  text="Banner Image"
                />
              </Form.Item>
            </Card>

            <Card size="small" title="Intro Section " className="my-5">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <Form.Item
                  label="First Image"
                  name={["intro_Section", "first_image"]}
                >
                  <UploadFoodImage
                    maxUploadCount={1}
                    isCropTrue={false}
                    bannerAspect={3 / 1}
                    text="First Image"
                  />
                </Form.Item>

                <Form.Item
                  label="Second Image"
                  name={["intro_Section", "second_image"]}
                >
                  <UploadFoodImage
                    maxUploadCount={1}
                    isCropTrue={false}
                    bannerAspect={1 / 1}
                    text="Second Image"
                  />
                </Form.Item>
              </div>

              <Form.List name={["intro_Section", "points"]}>
                {(fields, { add, remove }) => (
                  <>
                    <label className="font-medium block mb-2">Intro Points</label>

                    {fields.map(({ key, name }) => (
                      <div key={key} className="flex items-center gap-3 w-full">
                        <Form.Item
                          name={name}
                          rules={[{ required: true, message: "Enter point" }]}
                          className="flex-1 mb-0"
                        >
                          <Input placeholder="Enter point" />
                        </Form.Item>

                        <MinusCircleOutlined
                          onClick={() => remove(name)}
                          className="text-red-500 cursor-pointer"
                        />
                      </div>
                    ))}

                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Point
                    </Button>
                  </>
                )}
              </Form.List>
            </Card>

            <Card size="small" title="Key Benefits Section" className="mt-4">

            <Form.Item
              label="Section Title"
              name={["key_benefits_section", "title"]}
            >
              <Input placeholder="Section title"/>
            </Form.Item>

            <Form.Item
              label="Section Description"
              name={["key_benefits_section", "description"]}
            >
              <TextArea rows={2} placeholder="Section Description"/>
            </Form.Item>

            <Form.List name={["key_benefits_section", "benefits"]}>
              {(fields, { add, remove }) => (
                <>
                  <label className="font-medium">Benefits</label>
                  {fields.map(({ key, name }) => (
                    <div key={key} className="border p-4 rounded mb-4">
                      <Form.Item
                        label="Icon"
                        name={[name, "icon"]}
                        rules={[{ required: true, message: "Enter icon" }]}
                      >
                        <UploadFoodImage
                          maxUploadCount={1}
                          isCropTrue={false}
                          bannerAspect={1 / 1}
                          text="Icon"
                        />
                      </Form.Item>

                      <Form.Item
                        label="Title"
                        name={[name, "title"]}
                        rules={[{ required: true, message: "Enter title" }]}
                      >
                        <Input placeholder="Title"/>
                      </Form.Item>

                      <Form.Item
                        label="Description"
                        name={[name, "description"]}
                      >
                        <TextArea rows={2} placeholder="Description"/>
                      </Form.Item>

                      <Button danger onClick={() => remove(name)}>
                        Remove
                      </Button>
                    </div>
                  ))}

                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                  >
                    Add Benefit
                  </Button>
                </>
              )}
            </Form.List>
            </Card>
          </Form>
        </Spin>
      </div>

      {/* BUTTONS */}
      <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
        <ButtonWrapper type="primary" onClick={handleSave} loading={isPending}>
          Save
        </ButtonWrapper>
        <ButtonWrapper onClick={() => navigate(-1)}>Cancel</ButtonWrapper>
      </div>
    </div>
  );
};

export default ServiceForm;
